(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentDialogController', CommentDialogController);

    CommentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Comment', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'Handbook'];

    function CommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comment, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, Handbook) {
        var vm = this;

        vm.comment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customusers = CustomUser.query();
        vm.specificquestions = SpecificQuestion.query();
        vm.answers = Answer.query();
        vm.frequentlyaskedquestions = FrequentlyAskedQuestion.query();
        vm.handbooks = Handbook.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.comment.id !== null) {
                Comment.update(vm.comment, onSaveSuccess, onSaveError);
            } else {
                Comment.save(vm.comment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:commentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationtime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
